import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const FLAT_TREE_NODE_PADDING = 26;
export const FLAT_TREE_NODE_VIRTUALIZED_DEFAULT_HEIGHT = 20;
export const FLAT_TREE_CHECKBOX_PADDING = 22;
export const FLAT_TREE_CHECKBOX_WIDTH = 55;
export const FLAT_NODE_PATH_SEPARATOR = '/';
export const BRACKETS_OFFSET = 15;
export const MO_IDS_SEPARATOR = ',';
export const SELECT_TREE_ALL_CHECKED = 'All';
export const ARRAY_NODE_KEY = 'ARRAY_NODE_KEY';
export const EFlatTreeNodeTypes = {
	Array: 'array',
	Object: 'object',
} as const;

export type TFlatTreeNodeTypes = TValueOfStringRecord<typeof EFlatTreeNodeTypes>
